var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.593 8.404h17.824M14.942 12.31h.01M10.505 12.31h.009M6.058 12.31h.01M14.942 16.196h.01M10.505 16.196h.009M6.058 16.196h.01M14.544 1v3.29M6.466 1v3.29",
    stroke: "#ED1B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.738 2.58H6.271C3.334 2.58 1.5 4.214 1.5 7.221v9.05C1.5 19.326 3.334 21 6.271 21h8.458c2.946 0 4.771-1.645 4.771-4.652V7.222c.01-3.007-1.816-4.643-4.762-4.643z",
    stroke: "#ED1B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCalendar;